import { render } from "./ProductParam.vue?vue&type=template&id=45721d4f"
import script from "./ProductParam.vue?vue&type=script&lang=js"
export * from "./ProductParam.vue?vue&type=script&lang=js"
script.render = render

export default script